
<div :class="classes(n())">
  <Picker
    ref="pickerRef"
    :model-value="internalValues"
    :value="internalValues"
    :visible="visible"
    :columns="dateColumns"
    :title="title"
    :confirm-button-text="confirmButtonText"
    :show-close="showClose"
    :close-on-click-overlay="closeOnClickOverlay"
    :disabled="disabled"
    :teleport="teleport"
    :lock-scroll="lockScroll"
    :destroy-on-close="destroyOnClose"
    :visible-option-num="visibleOptionNum"
    :option-height="optionHeight"
    :swipe-duration="swipeDuration"
    @update:visible="handleVisibleChange"
    @confirm="handleConfirm"
    @cancel="handleCancel"
    @change="handleChange"
  >
    <template
      v-if="$slots.toolbar"
      #toolbar
    >
      <slot name="toolbar" />
    </template>
    <template
      v-if="$slots.title"
      #title
    >
      <slot name="title" />
    </template>
    <template
      v-if="$slots.option"
      #option="slotProps"
    >
      <slot
        name="option"
        v-bind="slotProps"
      />
    </template>
    <template
      v-if="$slots['columns-top']"
      #columns-top
    >
      <slot name="columns-top" />
    </template>
    <template
      v-if="$slots['columns-bottom']"
      #columns-bottom
    >
      <slot name="columns-bottom" />
    </template>
    <template
      v-if="$slots.confirm"
      #confirm
    >
      <slot name="confirm" />
    </template>
  </Picker>
</div>
